var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59881 21.2497C9.40881 21.2497 9.21881 21.1797 9.06881 21.0297L4.05881 16.0197C3.76881 15.7297 3.76881 15.2497 4.05881 14.9597C4.34881 14.6697 4.82881 14.6697 5.11881 14.9597L10.1288 19.9697C10.4188 20.2597 10.4188 20.7397 10.1288 21.0297C9.97881 21.1697 9.78881 21.2497 9.59881 21.2497Z",
    fill: "#3A3441"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59863 21.25C9.18863 21.25 8.84863 20.91 8.84863 20.5V3.5C8.84863 3.09 9.18863 2.75 9.59863 2.75C10.0086 2.75 10.3486 3.09 10.3486 3.5V20.5C10.3486 20.91 10.0086 21.25 9.59863 21.25Z",
    fill: "#3A3441"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5988 9.26043C20.4088 9.26043 20.2188 9.19043 20.0688 9.04043L15.0588 4.03043C14.7688 3.74043 14.7688 3.26043 15.0588 2.97043C15.3488 2.68043 15.8288 2.68043 16.1188 2.97043L21.1288 7.98043C21.4188 8.27043 21.4188 8.75043 21.1288 9.04043C20.9788 9.19043 20.7888 9.26043 20.5988 9.26043Z",
    fill: "#3A3441"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5791 21.25C15.1691 21.25 14.8291 20.91 14.8291 20.5V3.5C14.8291 3.09 15.1691 2.75 15.5791 2.75C15.9891 2.75 16.3291 3.09 16.3291 3.5V20.5C16.3291 20.91 15.9991 21.25 15.5791 21.25Z",
    fill: "#3A3441"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSwap);
export default __webpack_public_path__ + "static/media/arrow-swap.5fe5becc7944e0b3d19e8f66384db95d.svg";
export { ForwardRef as ReactComponent };